<template>
	<div>
		<div  style="display: flex;flex-direction: row;align-items: center;justify-content: center; width: 80%;">
			<span style="margin-right: 0.625rem;font-size: 0.6875rem;">选择年份</span>
			<a-input-number v-model="theYear"  :max = "currentYear" :min="2015" :precision="0" 
			   style="width: 6.25rem; margin-right: 0.625rem;font-size: 0.6875rem;"/>
			<a-button  icon="search" size="small" @click="queryData"  :disabled="loading1||loading2||loading3">查询</a-button>
			<a-button :disabled="loading1||loading2||loading3" type="primary"  icon="export" size="small" @click="exportData"  :loading="exporting" style="margin-left: 0.625rem;">结算统计导出</a-button>
		</div>
		<span>小区结算记录</span>
		<a-table size="small" :columns="columns1" :data-source="deductList"  bordered  rowKey="settleid"  :loading="loading1"
						:pagination="false" :scroll="{y:350}" style="margin: 0.8rem 0;">
					<span slot="readTimeSlot" slot-scope="text, record">
						{{getTimeFormatter(record.startTime)}}
					</span>
		</a-table>
		<span>小区结算统计</span>
		<a-table size="small" :columns="columns2" :data-source="deductStatisList"  bordered  rowKey="settleid"  :loading="loading2"
						:pagination="false" :scroll="{y:350}"  style="margin:0.8rem 0;" :row-class-name="isTotalRow">
		</a-table>
		<span>企业结算统计</span>
		<a-table size="small" :columns="columns3" :data-source="deductStatisList4Enterprise"  bordered  rowKey="settleid"  :loading="loading3"
						:pagination="false"   style="margin:0.8rem 0;">
		</a-table>
	</div>	
</template>

<script>
	export default{
		data(){
			const  columns1 = [
				{
					title: '小区',
					dataIndex: 'n_name',
					className:'v-cell',
					align:'center',
				},
				{
					title: '用量',
					dataIndex: 'yl',
					className:'v-cell',
					align:'center',
				},
				{
					title: '金额',
					dataIndex: 'demoney',
					className:'v-cell',
					align:'center',
				},
				{
					title: '结算月',
					dataIndex: 'startTime',
					scopedSlots:{customRender:'readTimeSlot'},
					align:'center',
					className:'v-cell',
				},
			];
			const  columns2 = [
				{
					title: '小区',
					dataIndex: 'n_name',
					className:'v-cell',
					align:'center',
				},
				{
					title: '用量',
					dataIndex: 'yl',
					className:'v-cell',
					align:'center',
				},
				{
					title: '金额',
					dataIndex: 'demoney',
					className:'v-cell',
					align:'center',
				},
				{
					title: '一阶用量',
					dataIndex: 'firstyl',
					align:'center',
					className:'v-cell',
				},
				{
					title: '二阶用量',
					dataIndex: 'secondyl',
					align:'center',
					className:'v-cell',
				},
				{
					title: '三阶用量',
					dataIndex: 'thirdyl',
					align:'center',
					className:'v-cell',
				},
				{
					title: '阶梯用水总量',
					dataIndex: 'jtYl',
					align:'center',
					className:'v-cell',
				},
				{
					title: '非居民用水总量',
					dataIndex: 'nonPeopleYl',
					align:'center',
					className:'v-cell',
				},
				{
					title: '阶梯用户数',
					dataIndex: 'jtHuNum',
					align:'center',
					className:'v-cell',
				},
				{
					title: '非居民用户数',
					dataIndex: 'nonPeppleHuNum',
					align:'center',
					className:'v-cell',
				},
			];	
			const  columns3 = [
				{
					title: '小区',
					dataIndex: 'n_name',
					className:'v-cell',
					align:'center',
				},
				{
					title: '用量',
					dataIndex: 'yl',
					className:'v-cell',
					align:'center',
				},
				{
					title: '金额',
					dataIndex: 'demoney',
					className:'v-cell',
					align:'center',
				},
				{
					title: '工业用量',
					dataIndex: 'gyYl',
					align:'center',
					className:'v-cell',
				},
				{
					title: '建筑用量',
					dataIndex: 'jzYl',
					align:'center',
					className:'v-cell',
				},
				{
					title: '企业居民用量',
					dataIndex: 'jmYl',
					align:'center',
					className:'v-cell',
				},
				{
					title: '减免量',
					dataIndex: 'minusderead',
					align:'center',
					className:'v-cell',
				},
				{
					title: '转到虚表',
					dataIndex: 'tovirtual',
					align:'center',
					className:'v-cell',
				},
				
			];	
			return{
				columns1,
				columns2,
				columns3,
				deductList:[],
				deductStatisList:[],
				deductStatisList4Enterprise:[],
				theYear:new Date().getFullYear(),
				currentYear:new Date().getFullYear(),
				loading1:false,
				loading2:false,
				loading3:false,
				exporting:false,
			}
		},
		methods:{
			exportData:function(){
				this.exporting = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_WATER_DEDUCT_STATIS_EXPORT_URL);
				let param = {year:this.theYear};
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exporting = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '结算用水统计.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exporting = false;
					console.log(error);
				});
			},
			isTotalRow:function(record,index){
				if((this.deductStatisList.length-1) == index){
					return "last_row";
				}
			},
			queryData:function(){
				this.queryDeductData();
				this.queryDeductStatisData();
				this.queryDeductStatis4Enterprise();
			},
			queryDeductData:function(){
				this.loading1 = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_WATER_DEDUCT_LIST_URL);
				let param = {year:this.theYear};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading1 = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.deductList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading1 = false;
					console.log(error);
				});
			},
			
			queryDeductStatisData:function(){
				this.loading2 = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_WATER_DEDUCT_STATIS_URL);
				let param = {year:this.theYear};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading2 = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.deductStatisList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading2 = false;
					console.log(error);
				});
			},
			queryDeductStatis4Enterprise:function(){
				this.loading3 = true;
				let url = this.Api.getLastUrl(this.Api.STATIS_WATER_DEDUCT_STATIS_ENTERPRISE_URL);
				let param = {year:this.theYear};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading3 = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.deductStatisList4Enterprise = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading3 = false;
					console.log(error);
				});
			},
			getTimeFormatter:function(dateTime){
				if(dateTime == null){
					return "";
				}else{
					let date = new Date(dateTime);
					return this.Config.formatDate(date);
				}
			},
		},
		created(){
			this.queryData();
		},
		
	}
</script>
<style>
	.v-cell{
		background-color: white;
		font-size: 0.6875rem;
		color: #000;
		font-family: "arial,sans-serif";
	}
	.last_row{
		background-color: #FFE48A;
		color: white;
		font-weight: bold;
	}
	/deep/  .ant-table-thead > tr > th {
	   color: #333;
			font-weight: bold;
			background-color: #F8F8F9;
	 }
</style>
